import type { IAPIMessage } from '../../apiResponse';
import { APIClientError } from './api-client-error';

export class APIResponseError extends APIClientError {
  public readonly messages?: IAPIMessage[];
  public readonly data?: unknown;

  public constructor({
    message,
    status,
    statusText,
    messages,
    data,
    path,
  }: {
    message: string;
    status: number;
    statusText?: string;
    messages?: IAPIMessage[];
    data?: unknown;
    path?: string;
  }) {
    super(message, status, statusText, path);
    this.name = 'APIResponseError';
    Object.defineProperty(this, 'messages', { value: messages, writable: false });
    Object.defineProperty(this, 'data', { value: data, writable: false });
  }
}
